var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949495",
    fillRule: "evenodd",
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM5.6 9.375a.375.375 0 1 0 0 .75h4.8a.375.375 0 1 0 0-.75H5.6Zm5.134-2.088c-.23.23-.906.22-1.141.208a.09.09 0 0 1-.087-.086c-.011-.235-.022-.91.21-1.141a.72.72 0 0 1 1.018 1.019Zm-4.31.208c-.235.012-.91.023-1.142-.208a.72.72 0 1 1 1.02-1.02c.23.232.22.907.208 1.142a.09.09 0 0 1-.087.086Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubter);
export default __webpack_public_path__ + "static/media/doubter.56ab68ed32e3d93906f101079942d5b8.svg";
export { ForwardRef as ReactComponent };